












































export default {
  name: 'PlanCard',
  props: {
    plan: {
      type: Object,
      required: true,
    },
  },
  computed: {
    actionTextKey() {
      if (this.plan.status === 'select') {
        return this.plan.isActive
          ? 'SIGNUP.BUTTON.SELECTED'
          : 'SIGNUP.BUTTON.SELECT';
      } else if (this.plan.status === 'upgrade') return 'SIGNUP.BUTTON.UPGRADE';
      else if (this.plan.status === 'reactivate')
        return 'SIGNUP.BUTTON.REACTIVATE';
      else if (this.plan.status === 'current')
        return 'SIGNUP.BUTTON.CURRENT_PLAN';
      return null;
    },
    actionColor() {
      return this.plan.isActive ? 'brand' : 'brand';
    },
    isDisabled() {
      return ['current', 'lower-tier'].includes(this.plan.status);
    },
  },
};
